import { render } from "./GTProjectList.vue?vue&type=template&id=25a90f3c&scoped=true"
import script from "./GTProjectList.vue?vue&type=script&lang=js"
export * from "./GTProjectList.vue?vue&type=script&lang=js"

import "./GTProjectList.vue?vue&type=style&index=0&id=25a90f3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-25a90f3c"

export default script